export default __webpack_public_path__ + "static/modal03_02-a597d09c33b33f875c86d4a4177ced05.jpg";